export const API_NAME_FORMAT = 'masked-balanced-length-v2';

export const maskApiUsername = (name) => {
  const characters = Array.from(String(name || ''));
  const length = characters.length;
  if (length <= 1) return '****';
  const leading = length <= 6 ? 1 : length <= 10 ? 2 : 3;
  const trailing = length <= 4 ? 0 : length <= 10 ? 1 : 2;
  return `**${characters.slice(leading, length - trailing).join('')}**`;
};

export const maskApiLeaderboard = (payload) => {
  if (payload?.source !== 'stake_api' || payload.name_format === API_NAME_FORMAT || !Array.isArray(payload.entries)) return payload;
  return {
    ...payload,
    name_format: API_NAME_FORMAT,
    entries: payload.entries.map((entry) => {
      const name = String(entry.user || '');
      // Do not trim an already masked legacy response a second time during rollout.
      return { ...entry, user: name.startsWith('**') && name.endsWith('**') ? name : maskApiUsername(name) };
    }),
  };
};

// Never briefly render an old local API identity while the current source loads.
// Branding/settings remain available; live rows arrive through the source API.
export const withoutCachedStandings = (state) => ({
  ...state,
  topThree: [],
  leaderboard: [],
  exclusive: { ...state.exclusive, topThree: [], leaderboard: [] },
});